import React from 'react';

const ComponentsSection = ({content}) => {
    return (
        <section className="components">
            <div className="container">
                <div className="decorate-container">
                    <div className="decorate">
                        <span className="decorate__item"/>
                        <span className="decorate__item"/>
                    </div>
                </div>
                <div className="row components--header section--header">
                    <div id="develop_components"/>
                    <div className="col-lg-6">
                        <h2>Components à la carte </h2>
                    </div>
                    <div className="col-lg-5 offset-lg-1">
                        <p>Agoric is built on a JavaScript library of reusable, composable components coded by
                            experienced community members.</p>
                    </div>
                </div>
                <div className="row components--container">
                    <div className="col-lg-12">
                        <h3>The Basics</h3>
                    </div>
                </div>
                <div className="row pb-5 px-4 px-xl-0">
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Local Currency</h5>
                            <p>Accept BLD in your contract with a couple lines of code.<br/><br/></p>
                            <p className="status">Component</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Fungible Tokens</h5>
                            <p>Launch your own project token quickly using ERTP.<br/><br/></p>
                            <p className="status">Component</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Non-Fungible Tokens</h5>
                            <p>Non-fungible token rights management is straightforward with ERTP.</p>
                            <p className="status">Component</p>
                        </div>
                    </div>

                </div>
                <div className="row components--container">
                    <div className="col-lg-12">
                        <h3>Component</h3>
                    </div>
                </div>
                <div className="row pb-5 px-4 px-xl-0">
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>AMM</h5>
                            <p>Agoric’s “Swap” is an X*Y=K automated market maker that’s pluggable and reusable.</p>
                            <p className="status yellow">Component</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Vaults & Loans</h5>
                            <p>Accept supplied capital, make loans, and charge interest.<br/><br/></p>
                            <p className="status yellow">Component</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Covered Call</h5>
                            <p>An option contract that can represent a large variety of exchanges of rights.</p>
                            <p className="status yellow">Component</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>OTC Desk</h5>
                            <p>An off-chain quoting desk that takes advantage of on-chain liquidity.</p>
                            <p className="status yellow">Component</p>
                        </div>
                    </div>
                </div>
                <div className="row components--container">
                    <div className="col-lg-12">
                        <h3>Real-World Data</h3>
                    </div>
                </div>
                <div className="row pb-5 px-4 px-xl-0">
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Price Authority</h5>
                            <p>Easy API integration for pricing data, including proactively waking up your
                                contract. </p>
                            <p className="status torquise">Data</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>On-Chain Oracles</h5>
                            <p>Implement the price authority API for on-chain data.<br/><br/></p>
                            <p className="status torquise">Data</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Off-Chain Oracles</h5>
                            <p>Agoric’s integration with Chainlink allows easy connection to off-chain data and
                                services.</p>
                            <p className="status torquise">Data</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Connect to IBC</h5>
                            <p>Native connection to other IBC enabled chains.<br/><br/></p>
                            <p className="status torquise">Data</p>
                        </div>
                    </div>
                </div>
                <div className="row components--container">
                    <div className="col-lg-12">
                        <h3>UI Kits & Widgets</h3>
                    </div>
                </div>
                <div className="row pb-5 px-4 px-xl-0">
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>UI Widgets</h5>
                            <p>Components for rendering of key Agoric ERTP concepts like purses and amounts.</p>
                            <p className="status red">Widget</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>Notifiers</h5>
                            <p>Notify your UI of chain and wallet events and state updates.<br/><br/></p>
                            <p className="status red">Widget</p>
                        </div>
                    </div>
                    <div className="col-10 col-sm-6 col-md-3">
                        <div className="box">
                            <h5>React Dapps</h5>
                            <p>See our Treasury application for a React implementation.<br/><br/></p>
                            <p className="status red">Widget</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default ComponentsSection;